import { render, staticRenderFns } from "./dict-select.vue?vue&type=template&id=6d634bfc"
import script from "./dict-select.vue?vue&type=script&lang=js"
export * from "./dict-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports